import {API_ROUTES} from '../../config';
import { get } from '../../utils/superagent';

export const getTeam = async () => {
  return await get(API_ROUTES.team.get, {});
};
